module.exports = __webpack_public_path__ + "img/sw3-b1.18c093c4.jpg";